module.exports = __webpack_public_path__ + "static/media/oberflex-zebranot3-1200x2490.850414f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-zebranot3-1200x2490.jpg
// module id = 1070
// module chunks = 37